export function Sidebar1Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M9 10.914L10.086 12 9 13.086a1 1 0 101.414 1.414l1.793-1.793a1 1 0 000-1.414L10.414 9.5A1 1 0 109 10.914z"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8 2a6 6 0 00-6 6v8a6 6 0 006 6h8a6 6 0 006-6V8a6 6 0 00-6-6H8zm7 18V4H8a4 4 0 00-4 4v8a4 4 0 004 4h7zm2-15.874v15.748c1.725-.444 3-2.01 3-3.874V8a4.002 4.002 0 00-3-3.874z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
